import * as React from "react";
import { IProductModel } from "../../models";
import { useAppState, useCopy } from "../../containers";
import { Page, ProductList } from "../../components";

import products from "../../data/products.json";
import { useEffect, useRef, useState } from "react";
import { CartContainer } from "../../components/Cart/cart";

interface IShopProps {
  copy: {
    title: string;
  };
  products: IProductModel[];
  updateRef: (audioRef: React.RefObject<HTMLAudioElement>) => void;
}
const Shop: React.FC<IShopProps> = ({
  copy: { title },
  products,
  updateRef
}) => {
  const baseClassName = "shop";
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef && updateRef) {
      updateRef(audioRef);
    }
  }, [audioRef, updateRef]);

  return (
    <>
      <CartContainer />

      <Page
        width={"medium"}
        className={baseClassName}
        title={title}
        showFooter={true}
        showHeader={true}
      >
        <ProductList products={products} />

        <audio ref={audioRef} src={process.env.PUBLIC_URL + "/kupi.mp3"} />
      </Page>
    </>
  );
};

interface IShopContainerProps {
  products: IProductModel[];
}
export const ShopContainer: React.FC<IShopContainerProps> = props => {
  const copy = useCopy("shop");
  const { selectedProduct } = useAppState();

  const [audioRef, setAudioRef] = useState<React.RefObject<
    HTMLAudioElement
  > | null>(null);

  useEffect(() => {
    if (selectedProduct && audioRef && audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;

      audioRef.current.play();
    }
  }, [selectedProduct, audioRef]);

  return (
    // @ts-ignore
    <Shop {...props} copy={copy} products={products} updateRef={setAudioRef} />
  );
};
